import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    EDIT_PRODUCT,
    GET_PRODUCT_ASSURANCE, GET_PRODUCT_CONDITIONS, GET_PRODUCT_PROPERTIES, REGISTER_PRODUCT,
} from "./AdInsert.type";
import AdInsertService from "../services/AdInsert.service";
import {EditProductModel, RegisterProductModel} from "../models";

export const getProductAssurance = createAsyncThunk(
    GET_PRODUCT_ASSURANCE,
    async (productId:number) =>{
        const response = await AdInsertService.getProductAssurance(productId);
        return response.data;
    }
)
export const getProductProperties = createAsyncThunk(
    GET_PRODUCT_PROPERTIES,
    async (productId:number) =>{
        const response = await AdInsertService.getProductProperties(productId);
        return response.data;
    }
)
export const getProductConditions = createAsyncThunk(
    GET_PRODUCT_CONDITIONS,
    async (productId:number) =>{
        const response = await AdInsertService.getProductConditions(productId);
        return response.data;
    }
)
export const registerProduct = createAsyncThunk(
    REGISTER_PRODUCT,
    async (model:RegisterProductModel) =>{
        const response = await AdInsertService.registerProduct(model);
        return response.data;
    }
)
export const editProduct = createAsyncThunk(
    EDIT_PRODUCT,
    async (model:EditProductModel) =>{
        const response = await AdInsertService.editProduct(model);
        return response.data;
    }
)
